import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import DataContext from './DataContext/DataContext';
import NavBar from './NavBar';
import EmptyStyle from './ui/EmptyStyle';
import Skeleton from './DishGrid/Skeleton';

// TODO Implement loader for each view in the application to make skeleton more realistic. Then remove this.
const Loader = ({ children }) => {
  const { isFetching } = useContext(DataContext);
  const location =useLocation();
  const isErrorPage = location.pathname === '/error';
  if (!isFetching || isErrorPage) {
    return children;
  }

  return (
    <>
      <NavBar />
      <EmptyStyle />
      <Skeleton />
    </>
  );
};

export default Loader;
